// firebase Config 

export const apiKey = "AIzaSyBHRKcGGNQKaZHTiIsdIBkMmZSYGnGanGY"; 
export const authDomain = "geauxnet-tv.firebaseapp.com"; 
export const databaseURL = "https://geauxnet-tv.firebaseio.com"; 
export const projectId = "geauxnet-tv"; 
export const storageBucket = "geauxnet-tv.appspot.com"; 
export const messagingSenderId = "15948440340"; 
export const appId = "1:15948440340:web:55bbe7475378a5b7b05801"; 
export const measurementId = "G-4ZHG42C8YV"; 